module.exports = __webpack_public_path__ + "static/media/KrikeyFullwordLogo.396bc5c1.png";